/* eslint-disable max-len, no-unused-expressions, no-multi-spaces */

/* TODO: We created this custom element when we start creating the "medatsu' theme.
    We should rewrite this element so the other theme can also use it.
    We can differentiate between the themes with the "topbartype" attribute, which we define on each theme's typoscript.
    the "new theme" uses a topbartype="scrolling" and the older themes the topbartype="fixed".
    We should refactor this element, do we can use it on all other themes.
    We should also make sure we don't need to use any other elements outside of the topbar, like the header or nav.
 */

class ToujouTopbar extends HTMLElement {
  static get properties() {
    return {
      scrollPosition: { type: Number },
      lastScrollPosition: { type: Number },
      isPageWithHeader: { type: Boolean },
      headerHeight: { type: Number },
      isScrollUp: { type: Boolean },
    };
  }

  get type() {
    return this.getAttribute('topbartype');
  }

  constructor() {
    super();

    this.scrollPosition = null;
    this.lastScrollPosition = 0;
    this.isScrollUp = false;
    this.isPageWithHeader = null;
    this.headerHeight = 0;
    this.lastBackgroundStatus = null;
    this.lastBarVisibilityStatus = null;
    this.topbarHideOffset = document.querySelector('.top-bar').offsetHeight;
  }

  connectedCallback() {
    if (this.type === 'scrolling') {
      this._initScrollingTopbar();
    }

    window.addEventListener('scroll', () => {
      this.scrollPosition = this._getScrollPosition();
      this.isScrollUp = this._getScrollDirection();
      this.lastScrollPosition = this.scrollPosition;

      if (this.type === 'scrolling') {
        this._updateScrollingBarVisibility();
        this._updateScrollingBarBackground();
      }
    });

    this.addEventListener('toujou-burger-button-click', this._handleBurgerButtonClick);
  }

  /**
   * Get current scroll position.
   *
   * @returns {HTMLElement | number}
   * @private
   */
  _getScrollPosition() {
    return (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
  }

  /**
   * Get current scroll direction. up = true, down = false.
   *
   * @returns {boolean}
   * @private
   */
  _getScrollDirection() {
    return this.scrollPosition < this.lastScrollPosition;
  }

  /**
   * React to burger button click
   * Add/remove menuopen attribute from body, so Themes can prevent scroll while menu is open
   *
   * @param event
   * @private
   */
  _handleBurgerButtonClick(event) {
    event.detail.state
      ? document.body.setAttribute('menuopen', '')
      : document.body.removeAttribute('menuopen');
  }

  /**
   * Initialize the scrolling top-bar element:
   *  - check if page has header and set according variables
   *  - update visibility state
   *  - update background state
   *
   * @private
   */
  _initScrollingTopbar() {
    const header = document.querySelector('header');
    if (header) {
      this.isPageWithHeader = true;
      this.isPageWithHeader = header.offsetHeight;
    } else {
      this.isPageWithHeader = false;
    }

    this._updateScrollingBarVisibility();
    this._updateScrollingBarBackground();
  }

  /**
   * Toggle visibility classes
   *
   * @private
   */
  _updateScrollingBarVisibility() {
    const currentBarVisibilityStatus = this.scrollPosition > this.topbarHideOffset && !this.isScrollUp;
    if (currentBarVisibilityStatus === this.lastBarVisibilityStatus) return;

    if (currentBarVisibilityStatus) {
      this.classList.add('top-bar--scroll-hidden');
      this._dispatchTopbarEvent('toujou-topbar-hide');
    } else {
      this.classList.remove('top-bar--scroll-hidden');
      this._dispatchTopbarEvent('toujou-topbar-unhide');
    }

    this.lastBarVisibilityStatus = currentBarVisibilityStatus;
  }

  /**
   * Toggle background classes
   *
   * @private
   */
  _updateScrollingBarBackground() {
    const currentBackgroundStatus = !this.isPageWithHeader || this.scrollPosition > this.topbarHideOffset;
    if (currentBackgroundStatus === this.lastBackgroundStatus) return;

    if (currentBackgroundStatus) {
      this.classList.add('top-bar--with-background');
      this._dispatchTopbarEvent('toujou-topbar-add-background');
    } else {
      this.classList.remove('top-bar--with-background');
      this._dispatchTopbarEvent('toujou-topbar-remove-background');
    }

    this.lastBackgroundStatus = currentBackgroundStatus;
  }

  _dispatchTopbarEvent(eventName) {
    this.dispatchEvent(new CustomEvent(eventName, {
      bubbles: true,
      composed: true,
    }));
  }
}

customElements.define('toujou-topbar', ToujouTopbar);
